export default __webpack_public_path__ + "static/services-details1z-91152b3b5e7dec51501dba08532066e5.jpg";